import { _ as t } from "../internals/export.js";
import { f as r } from "../internals/fails.js";
import { t as o } from "../internals/to-object.js";
import { t as n } from "../internals/to-primitive.js";
t({
  target: "Date",
  proto: !0,
  arity: 1,
  forced: r(function () {
    return null !== new Date(NaN).toJSON() || 1 !== Date.prototype.toJSON.call({
      toISOString: function toISOString() {
        return 1;
      }
    });
  })
}, {
  toJSON: function toJSON(t) {
    var r = o(this),
      i = n(r, "number");
    return "number" != typeof i || isFinite(i) ? r.toISOString() : null;
  }
});